import React, { useState, useEffect } from "react";

import SliderLanguage from '../partials/SliderLanguage.js'
import BackArrow from '../partials/BackArrow.jsx'

export default function Overview(props) {

  const [history, setHistory] = useState([]);
  const isSpanish = props.spanish;

  // =========================
  // LANGUAGE CONTENT
  // =========================
  const content = {
    en: {
      introTitle: "Now that your measurments are done, let's explore your specific lens options!",
      introBullets: [
        "Watch the cataract overview video below",
        'When you are done, click the "Next" button',
        'If you have already seen this video, you can skip it by clicking the "Next" button'
      ],
      next: "Next",
      back: "Go Back",
      summaryTitle: "Your Vision Preferences",
      explore: "Explore your vision options*",
      disclaimer: "* The option you want may or may not be available depending on the shape of your eye and the health of your eye.",
      questions: [
        {
          id: 1,
          question: "When do you usually wear glasses?",
          options: [
            { id: "read", label: "I only look for glasses when I want to read or work on the computer" },
            { id: "takeOff", label: "I usually wear glasses, but take them off when I want to read" },
            { id: "fullTime", label: "I wear glasses most of the time" },
            { id: "allActivities", label: "I see well without glasses for all activities" }
          ]
        },
        {
          id: 2,
          question: "How often do you find yourself cleaning your glasses?",
          options: [
            { id: "never", label: "Never" },
            { id: "daily", label: "About once a day" },
            { id: "often", label: "Several times a day" }
          ]
        },
        {
          id: 3,
          question: "How do your glasses work in rain, snow, or windy weather?",
          options: [
            { id: "noProblem", label: "No problem" },
            { id: "challenging", label: "It can be a little challenging" },
            { id: "veryDifficult", label: "It's very difficult" }
          ]
        },
        {
          id: 4,
          question: "How often do you find yourself looking for your glasses?",
          options: [
            { id: "rarely", label: "Rarely" },
            { id: "frequent", label: "Frequently" },
            { id: "most", label: "Most the time" }
          ]
        },
        {
          id: 5,
          question: "Are you a pilot or professional driver?",
          options: [
            { id: "yes", label: "Yes" },
            { id: "no", label: "No" }
          ]
        },
        {
          id: 6,
          question: "After cataract surgery, what would make you happiest with your vision?",
          options: [
            { id: "distance", label: "Seeing clearly in the distance (driving, TV, outdoor activities)" },
            { id: "near", label: "Seeing clearly up close (reading, phone, hobbies)" },
            { id: "range", label: "Seeing clearly at many distances without switching glasses" },
            { id: "glasses", label: "Wearing glasses full time" }
          ]
        }
      ]
    },

    es: {
      introTitle: "Ahora que sus mediciones están completas, ¡exploremos sus opciones específicas de lentes!",
      introBullets: [
        "Vea el video de introducción sobre la catarata a continuación",
        'Cuando termine, haga clic en el botón "Siguiente"',
        'Si ya ha visto este video, puede omitirlo haciendo clic en el botón "Siguiente"'
      ],
      next: "Siguiente",
      back: "Regresar",
      summaryTitle: "Sus preferencias visuales",
      explore: "Explorar sus opciones de visión*",
      disclaimer: "* La opción que desea puede o no estar disponible dependiendo de la forma y salud de su ojo.",
      questions: [
        {
          id: 1,
          question: "¿Cuándo suele usar gafas?",
          options: [
            { id: "read", label: "Solo uso gafas cuando quiero leer o usar la computadora" },
            { id: "takeOff", label: "Generalmente uso gafas, pero me las quito cuando quiero leer" },
            { id: "fullTime", label: "Uso gafas la mayor parte del tiempo" },
            { id: "allActivities", label: "Veo bien sin gafas para todas las actividades" }
          ]
        },
        {
          id: 2,
          question: "¿Con qué frecuencia limpia sus gafas?",
          options: [
            { id: "never", label: "Nunca" },
            { id: "daily", label: "Aproximadamente una vez al día" },
            { id: "often", label: "Varias veces al día" }
          ]
        },
        {
          id: 3,
          question: "¿Cómo funcionan sus gafas con lluvia, nieve o viento?",
          options: [
            { id: "noProblem", label: "Sin problema" },
            { id: "challenging", label: "Puede ser un poco difícil" },
            { id: "veryDifficult", label: "Es muy difícil" }
          ]
        },
        {
          id: 4,
          question: "¿Con qué frecuencia busca sus gafas?",
          options: [
            { id: "rarely", label: "Rara vez" },
            { id: "frequent", label: "Frecuentemente" },
            { id: "most", label: "La mayor parte del tiempo" }
          ]
        },
        {
          id: 5,
          question: "¿Es piloto o conductor profesional?",
          options: [
            { id: "yes", label: "Sí" },
            { id: "no", label: "No" }
          ]
        },
        {
          id: 6,
          question: "Después de la cirugía de cataratas, ¿qué le haría más feliz con su visión?",
          options: [
            { id: "distance", label: "Ver claramente de lejos (conducir, TV, actividades al aire libre)" },
            { id: "near", label: "Ver claramente de cerca (leer, teléfono, pasatiempos)" },
            { id: "range", label: "Ver claramente a múltiples distancias sin cambiar gafas" },
            { id: "glasses", label: "Usar gafas todo el tiempo" }
          ]
        }
      ]
    }
  };

  const t = content[isSpanish ? "es" : "en"];
  const questionsBase = t.questions;

  const questions = questionsBase.map((q) => {
    if (q.id === 1) {
      return {
        ...q,
        branch: (id) => id === "read" ? 3 : id === "allActivities" ? 5 : 1
      };
    }
    if (q.id === 3) {
      return { ...q, branch: () => 2 };
    }
    return q;
  });

  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [selected, setSelected] = useState(null);
  const [showSummary, setShowSummary] = useState(false);

  const [started, setStarted] = useState(false);
  const [canFinish, setCanFinish] = useState(false);
  const [timerStarted, setTimerStarted] = useState(false);

  const handleVideoHover = () => {
    if (timerStarted) return;
    setTimerStarted(true);
    setTimeout(() => setCanFinish(true), 15000);
  };

  // ================= VIDEO STEP =================
  if (!started) {
    return (
      <>
        <div style={styles.container}>
          <div style={{display: 'flex', justifyContent: 'center', margin: '0 0 30px 0',}}>
            <SliderLanguage hook={props.spanish} setHook={props.setSpanish} />
          </div> 

          <div style={styles.instructions}>{t.introTitle}</div>

          <ul>
            {t.introBullets.map((b, i) => (
              <li key={i} style={styles.subtitle}>{b}</li>
            ))}
          </ul>
        </div>

        <div style={styles.container}>
          <div style={styles.videoWrapper} onMouseEnter={handleVideoHover}>
            <iframe
              src={
                isSpanish
                  ? "https://player.vimeo.com/video/1186383306"
                  : "https://player.vimeo.com/video/1174229631"
              }
              title="Video"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              style={styles.iframe}
            />
          </div>

          <button style={styles.blueButton} onClick={() => setStarted(true)}>
            {t.next}
          </button>
        </div>
      </>
    );
  }

  // ================= QUESTIONS =================
const handleAnswer = (option) => {
  setSelected(option.id);

  const current = questions[step];

  const updated = { ...answers, [current.id]: option.id };
  setAnswers(updated);

  setTimeout(() => {
    let nextStep;

    if (current.branch) {
      nextStep = step + current.branch(option.id);
    } else {
      nextStep = step + 1;
    }

    // push current step into history BEFORE moving forward
    setHistory(prev => [...prev, step]);

    if (nextStep >= questions.length) {
      setShowSummary(true);
    } else {
      setStep(nextStep);
    }

    setSelected(null);
  }, 200);
};

function handleBack() {

  // If we're on summary, go back into last question
  if (showSummary) {
    setShowSummary(false);
    const last = history[history.length - 1] ?? 0;
    setStep(last);
    setHistory(prev => prev.slice(0, -1));
    return;
  }

  // If we're on the first question → go back to video
  if (step === 0) {
    setStarted(false);
    setStep(0);
    setAnswers({});
    setSelected(null);
    setHistory([]);
    return;
  }

  // Normal back navigation (history-based)
  setHistory(prev => {
    const newHistory = [...prev];
    const lastStep = newHistory.pop();

    if (lastStep !== undefined) {
      setStep(lastStep);
    } else {
      setStep(step - 1);
    }

    return newHistory;
  });
}

  function getCurrentVision(answers) {
  switch (answers[1]) {
    case "read": return "see better far-away";
    case "takeOff": return "see better up-close";
    case "fullTime": return "use glasses full time";
    case "allActivities": return "have range-of-vision";
    default: return "";
  }
}

function getGoalVision(answers) {
  switch (answers[6]) {
    case "distance": return "see better far-away";
    case "near": return "see better up-close";
    case "range": return "have range-of-vision";
    case "glasses": return "use glasses full time";
    default: return "";
  }
}

function formatVisionText(value, isSpanish) {
  const map = {
    "see better far-away": isSpanish ? "ver mejor de lejos" : "see better far-away",
    "see better up-close": isSpanish ? "ver mejor de cerca" : "see better up-close",
    "use glasses full time": isSpanish ? "usar gafas todo el tiempo" : "use glasses full time",
    "have range-of-vision": isSpanish ? "tener un rango de visión" : "have range-of-vision"
  };

  return map[value] || value;
}

if (showSummary) {

  const current = getCurrentVision(answers);
  const goal = getGoalVision(answers);

  // 🔥 always sync outward when summary renders
  props.setCurrentVision(current);
  props.setGoalVision(goal);

  const matchText = getMatchText(current, goal, isSpanish);
  const riskText = getRiskGuidance(answers, goal, isSpanish);

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{t.summaryTitle}</h2>

      <div style={styles.summaryBox}>
        <p>
          {isSpanish ? (
            <>
              Actualmente <strong>{formatVisionText(current, isSpanish)}</strong>, y después de la cirugía preferiría{" "}
              <strong>{formatVisionText(goal, isSpanish)}</strong>, {matchText}
            </>
          ) : (
            <>
              You currently <strong>{formatVisionText(current, isSpanish)}</strong>, and after surgery, you would prefer to{" "}
              <strong>{formatVisionText(goal, isSpanish)}</strong>, {matchText}
            </>
          )}
        </p>

        {riskText}
      </div>

      <div style={styles.buttonRow}>
        <button
          style={styles.secondaryButton}
          onClick={() => {
            setShowSummary(false);
            handleBack();
          }}
        >
          {t.back}
        </button>

        <button
          style={styles.primaryButton}
          onClick={() => props.setShowOverview(false)}
        >
          {t.explore}
        </button>
      </div>

      <p style={{ marginTop: 20, fontSize: 14 }}>
        {t.disclaimer}
      </p>
    </div>
  );
}

  const q = questions[step];

  return (
    <div style={styles.container}>
      <div style={styles.progress}>
        {isSpanish
          ? `Pregunta ${step + 1} de ${questions.length}`
          : `Question ${step + 1} of ${questions.length}`}
      </div>

      <div style={styles.question}>{q.question}</div>

      <div style={styles.options}>
        {q.options.map((option) => {
          const isSelected = selected === option.id;

          return (
            <div
              key={option.id}
              onClick={() => handleAnswer(option)}
              style={{
                ...styles.card,
                ...(isSelected ? styles.selectedCard : {})
              }}
            >
              {option.label}
            </div>
          );
        })}
      </div>
      <button
        style={styles.secondaryButton}
        onClick={handleBack}
      >
        {t.back}
      </button> 

    </div>
  );
}


function getMatchText(current, goal, isSpanish) {

  
  const t = (en, es) => isSpanish ? es : en;

  // currently distance
  if (current === "see better far-away" && goal === "see better far-away") {
    return t(
      "which matches how your vision currently works for you.",
      "lo cual coincide con la forma en que su visión funciona actualmente."
    );
  }

  if (current === "see better far-away" && goal === "have range-of-vision") {
    return t(
      "which will allow you to be less dependent on glasses. Most people like this change because it restores most of your near vision.",
      "lo que le permitirá depender menos de las gafas. A la mayoría de las personas les gusta este cambio porque recupera gran parte de la visión de cerca."
    );
  }

  if (current === "see better far-away" && goal === "see better up-close") {
    return t(
      "which is the opposite of how you currently see. It's okay to do this, but it's uncommon unless your lifestyle has changed.",
      "lo cual es lo opuesto a cómo ve actualmente. Es posible hacerlo, pero no es común a menos que su estilo de vida haya cambiado."
    );
  }

  if (current === "see better far-away" && goal === "use glasses full time") {
    return t(
      "which will make you more dependent on glasses. Most people with your current vision would be more comfortable with the distance or range-of-vision options.",
      "lo que lo hará más dependiente de las gafas. La mayoría de las personas con su visión actual se sentirían más cómodas con las opciones de lejos o rango de visión."
    );
  }

  // currently near
  if (current === "see better up-close" && goal === "see better far-away") {
    return t(
      "which is the opposite of how you currently see. You will likely need reading glasses after surgery.",
      "lo cual es lo opuesto a cómo ve actualmente. Probablemente necesitará gafas para leer después de la cirugía."
    );
  }

  if (current === "see better up-close" && goal === "have range-of-vision") {
    return t(
      "which will allow you to be less dependent on glasses, although some patients feel their near vision isn't quite as strong.",
      "lo que le permitirá depender menos de las gafas, aunque algunos pacientes sienten que su visión de cerca no es tan fuerte."
    );
  }

  if (current === "see better up-close" && goal === "see better up-close") {
    return t(
      "which matches how your vision currently works for you.",
      "lo cual coincide con la forma en que su visión funciona actualmente."
    );
  }

  if (current === "see better up-close" && goal === "use glasses full time") {
    return t(
      "which will make you more dependent on glasses. Most people with your current vision prefer to maintain their near vision.",
      "lo que lo hará más dependiente de las gafas. La mayoría de las personas prefieren mantener su visión de cerca."
    );
  }

  // currently glasses dependent
  if (current === "use glasses full time" && goal === "see better far-away") {
    return t(
      "which will reduce your dependence on glasses for distance, but you will still need reading glasses.",
      "lo que reducirá su dependencia de las gafas para lejos, pero aún necesitará gafas para leer."
    );
  }

  if (current === "use glasses full time" && goal === "have range-of-vision") {
    return t(
      "which will reduce your dependence on glasses across multiple distances.",
      "lo que reducirá su dependencia de las gafas en múltiples distancias."
    );
  }

  if (current === "use glasses full time" && goal === "see better up-close") {
    return t(
      "which will reduce your dependence on glasses for near tasks, but you will need glasses for distance.",
      "lo que reducirá su dependencia de las gafas para cerca, pero necesitará gafas para lejos."
    );
  }

  if (current === "use glasses full time" && goal === "use glasses full time") {
    return t(
      "which matches how your vision currently works for you.",
      "lo cual coincide con la forma en que su visión funciona actualmente."
    );
  }

  // currently range
  if (current === "have range-of-vision" && goal === "see better far-away") {
    return t(
      "which will give you strong distance vision, but you will need glasses for near tasks.",
      "lo que le dará buena visión de lejos, pero necesitará gafas para tareas de cerca."
    );
  }

  if (current === "have range-of-vision" && goal === "have range-of-vision") {
    return t(
      "which matches how your vision currently works for you.",
      "lo cual coincide con la forma en que su visión funciona actualmente."
    );
  }

  if (current === "have range-of-vision" && goal === "see better up-close") {
    return t(
      "which will give you strong near vision, but you will need glasses for distance. Many patients regret losing distance vision.",
      "lo que le dará buena visión de cerca, pero necesitará gafas para lejos. Muchos pacientes lamentan perder la visión de lejos."
    );
  }

  if (current === "have range-of-vision" && goal === "use glasses full time") {
    return t(
      "which will make you more dependent on glasses than you are now.",
      "lo que lo hará más dependiente de las gafas que ahora."
    );
  }

  return "";
}

function getRiskGuidance(answers, goal, isSpanish) {

  const t = (en, es) => isSpanish ? es : en;

  // Professional driver / pilot risk
  if (answers[5] === "yes" && goal === "have range-of-vision") {
    return (
      <p>
        {t(
          'However, your job requires good night vision, and the "range-of-vision" option can cause rings and halos around lights at night. If this is a concern, choosing the distance option may reduce this effect.',
          'Sin embargo, su trabajo requiere buena visión nocturna, y la opción de "rango de visión" puede causar halos o anillos alrededor de las luces por la noche. Si esto le preocupa, elegir la opción de visión de lejos puede reducir este efecto.'
        )}
      </p>
    );
  }

  return "";
}


// ================= STYLES =================
const styles = {
  container: {
    maxWidth: "620px",
    margin: "auto",
    padding: "40px 40px 0 40px",
    textAlign: "center",
    fontFamily: "system-ui",
    zIndex: '100',
  },
  title: {
    fontSize: "26px",
    marginBottom: "20px"
  },
  progress: {
    color: "#777",
    marginBottom: "20px"
  },
  question: {
    fontSize: "24px",
    marginBottom: "25px"
  },
  options: {
    display: "flex",
    flexDirection: "column",
    gap: "14px"
  },
  card: {
    padding: "20px",
    borderRadius: "14px",
    border: "2px solid #e4e4e4",
    cursor: "pointer"
  },
  selectedCard: {
    background: "#2A6EF0",
    color: "white",
    border: "2px solid #2A6EF0"
  },
  summaryBox: {
    background: "#f6f8fc",
    padding: "25px",
    borderRadius: "12px",
    fontSize: "18px",
    lineHeight: "1.5"
  },
  blueButton: {
    width: "100%",
    maxWidth: "420px",
    margin: "30px auto 300px auto",
    padding: "16px 20px",
    background: "#007bff",
    border: "1px solid #007bff",
    borderRadius: "10px",
    color: "#FFF",
    fontSize: "clamp(16px, 4vw, 20px)",
    fontWeight: "600",
    textAlign: "center",
    cursor: "pointer",
    lineHeight: "1.3",
    whiteSpace: "normal",
    textDecoration: 'none',
  },
    buttonRow: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexWrap: "wrap", // 🔥 this makes it mobile-friendly
    marginTop: "25px"
  },
  primaryButton: {
    flex: "1 1 240px",
    maxWidth: "320px",
    marginTop: '30px',
    padding: "16px 20px",
    borderRadius: "10px",
    border: "none",
    background: "#2A6EF0",
    color: "white",
    fontSize: "clamp(16px, 4vw, 18px)",
    fontWeight: "600",
    cursor: "pointer",
    textDecoration: 'none',
  },

  secondaryButton: {
    flex: "1 1 160px",
    maxWidth: "220px",
    marginTop: '30px',
    padding: "16px 20px",
    borderRadius: "10px",
    border: "2px solid #ccc",
    background: "white",
    color: "#444",
    fontSize: "clamp(14px, 3.5vw, 16px)",
    cursor: "pointer",
    textDecoration: 'none',
  },
  videoWrapper: {
    position: "relative",
    width: "100%",
    paddingTop: "56.25%", // 16:9
    marginBottom: "30px"
  },
  iframe: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "12px",
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, .2), 0 3px 10px 0 rgba(0, 0, 0, .15)',
  },
  instructions: {
    fontSize: '34px',
    fontWeight: '600',
    textAlign: 'left',
  },
  subtitle: {
    fontSize: '24px',
    textAlign: 'left',
    margin: "20px 0 0 0",
  },

};

